import useGetAllPayments from 'modules/easyPay/hooks/useGetAllPayments'
import useSetTotalPayment from 'modules/easyPay/hooks/useSetTotalPayment'
import React from 'react'
import { useNavigate } from 'react-router-dom'

// Android fragment_box_list.xml cnsEasyPayment: solid #74B743, padding 16dp.
// Amount (26sp bold, dark_blue #09314C) + white subtitle on the RIGHT,
// white pill button (radius 16dp, dark text) on the LEFT.
export default function AccessPay() {
    const navigate = useNavigate()
    const { payments, isLoading } = useGetAllPayments(true)
    const { total, commission } = useSetTotalPayment(payments)
    return (
        <div className="bg-green-1 p-4 flex items-center gap-1.5">
            <div className="flex-1 min-w-0 text-right">
                {!isLoading && (
                    <p className="text-heading text-[26px] font-bold leading-tight text-right">
                        {Number(total + commission).toLocaleString()} تومان
                    </p>
                )}
                <p className="text-white text-sm font-normal text-right">
                    تعهدات قابل پرداخت شما
                </p>
            </div>
            <button
                className="shrink-0 bg-white rounded-[16px] px-4 py-1 text-black text-sm"
                onClick={() => navigate('/easy-pay')}
            >
                پرداخت آسان
            </button>
        </div>
    )
}
